var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"error"}},[_c('van-empty',{staticClass:"empty",attrs:{"image":"error","image-size":"180px","description":this.$route.params.type === 'paytype'
        ? '请使用微信支付宝或云闪付打开'
        : '此缴费页面未在规定的日期范围内'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }